import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  css,
  styled
} from '@mui/material';

export const AccordionWrapper = styled(MuiAccordion)`
  ${({ theme }) => css`
    background-color: transparent;
    border-top: 1px solid ${theme.palette.divider};

    &:before {
      display: none;
      opacity: 0;
    }

    &:first-of-type {
      border-top: none;
    }
  `}
`;

export const AccordionSummary = styled(MuiAccordionSummary)`
  ${({ theme }) => css`
    flex-direction: row-reverse;
    padding: 0;
    min-height: 36px;

    & .MuiAccordionSummary-expandIconWrapper {
      margin-right: ${theme.spacing(1)};
      margin-bottom: ${theme.spacing(0.25)};
    }

    & .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
      transform: rotate(90deg);
    }

    & .MuiAccordionSummary-content {
      margin: 0;
      align-items: baseline;
    }
  `}
`;

export const AccordionDetails = styled(MuiAccordionDetails)`
  ${({ theme }) => css`
    padding: ${theme.spacing(0, 0, 2, 3)};
  `}
`;
